export class ProfileInfoResponse {
    firstName: string;
    lastName: string;
    email: string;
}

export class ProfileInfoRequest {
    reportUniqueId: string;
}